import { render, staticRenderFns } from "./warnStatus.vue?vue&type=template&id=45348af0&scoped=true&"
import script from "./warnStatus.vue?vue&type=script&lang=js&"
export * from "./warnStatus.vue?vue&type=script&lang=js&"
import style0 from "./warnStatus.vue?vue&type=style&index=0&id=45348af0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45348af0",
  null
  
)

export default component.exports